import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, GroupService} from "../services";
import {Subject} from "rxjs";

@Component({
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss',]
})


export class GroupComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private groupService: GroupService,
        private alertService: AlertService
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.groupService.getAll().subscribe((res: any[])=>{
            this.rows = res;
            this.loadingIndicator = false;
        },
        error => {
            this.alertService.error(error);
        })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
